
import {
  defineComponent, PropType, ref, computed,
} from 'vue';
import { useRouter, useRoute } from 'vue-router';
import BottomPopUpItem from '@/components/BottomPopUp/BottomPopUpItem.vue';
import AppBottomPopUp from '@/components/BottomPopUp/AppBottomPopUp.vue';
import { BOTTOM_POPUP_TYPES, MEDIA_TYPES } from '@/types/enums';
import { ICase } from '@/types/interfaces';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import { useMainStore } from '@/store/mainStore';
import useHeaderBooleans from '@/composables/UseHeaderBooleans';

export default defineComponent({
  components: {
    BottomPopUpItem,
    AppBottomPopUp,
  },
  props: {
    iCase: { type: Object as PropType<ICase>, required: true },
  },
  emits: ['close', 'openMovePopUp', 'deleteCase', 'saveCaseAsCopy', 'removeSharing', 'open-reorder-photo'],
  setup(props, { emit }) {
    const router = useRouter();
    const route = useRoute();
    const driveStore = useDriveStore();
    const mainStore = useMainStore();

    const isCaseDeleting = ref(false);

    const isMy = computed(() => driveStore.currentCase?.owner?.accountId === mainStore.user.accountId);
    const isNetwork = computed(() => route.meta.isNetwork);

    const photoUploading = computed(() => mainStore.mediaUploading);

    const showUnSharingMenu = computed(() => {
      const cid = driveStore.currentCase?.id;
      if (!cid) return false;
      return driveStore.networkCases.data.filter((el) => el.id === cid)[0].unShareable || false;
    });

    const { actionBar } = useHeaderBooleans();

    function hidePopUp() {
      emit('close');
    }

    function editCase() {
      driveStore.currentCase.filesAmount = driveStore.currentCase.files.length;
      driveStore.currentCase.photosAmount = driveStore.currentCase.photos.length;
      hidePopUp();
      router.push(`/drive/case/${props.iCase.id}/edit`);
    }

    function openMovePopUp() {
      emit('openMovePopUp');
    }

    function openInfoPopUp() {
      emit('close');
      mainStore.BottomPopUpType = BOTTOM_POPUP_TYPES.CASE_INFO;
    }

    function deleteCase() {
      emit('deleteCase');
    }

    function saveCaseAsCopy() {
      emit('saveCaseAsCopy');
    }

    function removeSharing() {
      emit('removeSharing');
    }

    function reorderPhoto() {
      emit('open-reorder-photo');
    }

    return {
      editCase,
      deleteCase,
      saveCaseAsCopy,
      hidePopUp,
      openMovePopUp,
      openInfoPopUp,
      removeSharing,
      reorderPhoto,
      isCaseDeleting,
      router,
      MEDIA_TYPES,
      isNetwork,
      isMy,
      showUnSharingMenu,
      actionBar,
      photoUploading,
    };
  },
});
